var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t(
        "label_essweb_ClaimRecord_form_dialog_changePaymentStatusTitle"
      ),
      dialog: _vm.show,
      width: "600",
      maxWidth: "600",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_ClaimRecord_form_dialog_paymentStatusLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            filled: "",
                            items: _vm.paymentStatus,
                            "append-icon": "arrow_drop_down",
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            dense: "",
                            "menu-props": {
                              offsetY: true,
                              transition: "slide-y-transition",
                              rounded: true,
                              contentClass: "elevation-4",
                            },
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "single-line": "",
                            placeholder: _vm.$t(
                              "label_essweb_ClaimRecord_form_dialog_paymentStatusLabel"
                            ),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.Data.payment_status_uuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "payment_status_uuid", $$v)
                            },
                            expression: "Data.payment_status_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_ClaimRecord_form_dialog_paymentMethodsLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-autocomplete", {
                          attrs: {
                            filled: "",
                            items: _vm.paymentMethods,
                            "append-icon": "arrow_drop_down",
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            dense: "",
                            "menu-props": {
                              offsetY: true,
                              transition: "slide-y-transition",
                              rounded: true,
                              contentClass: "elevation-4",
                            },
                            "single-line": "",
                            placeholder: _vm.$t(
                              "label_essweb_ClaimRecord_form_dialog_paymentMethodsLabel"
                            ),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.Data.payment_method,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "payment_method", $$v)
                            },
                            expression: "Data.payment_method",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            label: _vm.$t(
                              "label_essweb_ClaimRecord_form_dialog_paymentReferenceLabel"
                            ),
                          },
                          model: {
                            value: _vm.Data.payment_reference,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "payment_reference", $$v)
                            },
                            expression: "Data.payment_reference",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { saveBtn: "" },
              on: { save: _vm.toSave, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }